(function ($) {
  "use strict";

  var ACS = {
    init: function () {
      this.bindEvents();
    },

    bindEvents: function () {
      $(document).on("click", ".acs-cart-toggle", this.toggleCart.bind(this));
      $(document).on("click", ".acs-overlay", this.closeCart.bind(this));
      $(document).on("click", ".acs-cart-close", this.closeCart.bind(this));
      $(document).on("keydown", this.handleKeydown.bind(this));

      $(document).on(
        "submit",
        ".acs-add-to-cart-form",
        this.addToCart.bind(this)
      );
      $(document).on(
        "submit",
        ".acs-quick-add-form",
        this.addToCart.bind(this)
      );

      $(document).on(
        "click",
        ".acs-quantity-minus",
        this.updateQuantity.bind(this)
      );
      $(document).on(
        "click",
        ".acs-quantity-plus",
        this.updateQuantity.bind(this)
      );
      $(document).on(
        "change",
        ".acs-quantity-input",
        this.updateQuantity.bind(this)
      );

      $(document).on("click", ".acs-remove-item", this.removeItem.bind(this));
    },

    /* ---------- CART UI ---------- */
    toggleCart: function (e) {
      e.preventDefault();
      if (document.body.classList.contains('template-cart')) {
        return;
      }
      this.fetchCart(true);
    },

    closeCart: function () {
      $("body").removeClass("acs-open");
      this.restoreFocus();
    },

    handleKeydown: function (e) {
      if (e.key === "Escape" && $("body").hasClass("acs-open")) {
        this.closeCart();
      }
    },

    /* ---------- ADD TO CART ---------- */
    addToCart: function (e) {
      e.preventDefault();
      var $form = $(e.target);
      var $formbtn = $form.find('button[type="submit"], input[type="submit"]');
      $formbtn.prop("disabled", true);
      $formbtn.addClass("disabled");
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: $form.serialize(),
        dataType: "json",
        success: this.addToCartSuccess.bind(this, $form),
        error: this.addToCartError.bind(this, $form),
      });
    },

    addToCartSuccess: function ($form) {
      var $formbtn = $form.find('button[type="submit"], input[type="submit"]');
      $formbtn.prop("disabled", false);
      $formbtn.removeClass("disabled");
      this.updateCartBadge();
      this.fetchCart(true);
    },

    /* ---------- FETCH + RENDER CART ---------- */
    fetchCart: function (open) {
      $.getJSON(
        "/cart.js",
        function (cart) {
          this.renderCart(cart);
          if (open) $("body").addClass("acs-open");
        }.bind(this)
      );
    },

    renderCart: function (cart) {
      var $content = $(".acs-cart-content"),
        $subtotal = $(".acs-cart-subtotal"),
        $discounts = $(".acs-cart-discounts"),
        $duties = $(".acs-cart-duties"),
        $tax = $(".acs-cart-tax"),
        $total = $(".acs-cart-total"),
        itemsHtml = "";
      cart.items.forEach(
        function (item, index) {
          itemsHtml += this.renderCartItem(item, index);
        }.bind(this)
      );

      if (cart.item_count === 0) {
        itemsHtml = '<p class="empty-cart">Your Shopping Bag is Empty </p>';
      }

      // Render items
      $content.html(itemsHtml);

      // Cart-Level Summary
      $subtotal.html(
        `<strong>Subtotal:</strong> ${this.formatMoney(
          cart.items_subtotal_price
        )}`
      );

      // Cart-level discounts
      if (cart.cart_level_discount_applications?.length) {
        let dhtml = "<strong>Discounts:</strong>";
        dhtml += `<div class="acs_card_dis_row">`;
        cart.cart_level_discount_applications.forEach((d) => {
          dhtml += `<div class="acs-cart-discount-item">${
            d.title
          } <strong>(- ${this.formatMoney(d.total_allocated_amount)})</strong><button
                        type="button"
                        id="remove-discount"
                        class="discount-remove"
                      >
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.33105 7.35551C7.24833 7.35557 7.16889 7.38884 7.11035 7.4473L7.11035 7.44633L0.610349 13.9463L0.604489 13.9532L0.597654 13.959C0.567056 13.9876 0.542427 14.0223 0.525388 14.0606C0.508429 14.0987 0.499807 14.1399 0.499021 14.1817C0.49828 14.2236 0.505764 14.2658 0.521482 14.3047C0.537151 14.3434 0.560329 14.3787 0.589841 14.4082C0.619515 14.4379 0.655423 14.4619 0.694333 14.4776C0.733093 14.4932 0.774629 14.5008 0.816403 14.5C0.858362 14.4993 0.900141 14.4898 0.938474 14.4727C0.976672 14.4556 1.01151 14.431 1.04004 14.4004L1.0459 14.3936L1.05273 14.3877L6.97852 8.47953L7.33105 8.12797L7.68457 8.47953L13.6103 14.3877L13.623 14.4004C13.6517 14.4311 13.6863 14.4556 13.7246 14.4727C13.7628 14.4897 13.8039 14.4993 13.8457 14.5C13.8877 14.5008 13.9298 14.4933 13.9687 14.4776C14.0076 14.4619 14.0426 14.4379 14.0723 14.4082C14.1019 14.3786 14.1259 14.3436 14.1416 14.3047C14.1573 14.2658 14.1648 14.2236 14.1641 14.1817C14.1633 14.1399 14.1537 14.0988 14.1367 14.0606C14.1196 14.0223 14.0952 13.9876 14.0645 13.959L14.0518 13.9463L7.55273 7.44633L7.55176 7.4473C7.49316 7.38878 7.41387 7.35551 7.33105 7.35551Z" stroke="#000000"/>
                          <path d="M7.33301 7.64457C7.41573 7.64451 7.49517 7.61124 7.55371 7.55278V7.55375L14.0537 1.05375L14.0596 1.04692L14.0664 1.04106C14.097 1.01249 14.1216 0.977736 14.1387 0.939495C14.1556 0.901344 14.1643 0.86014 14.165 0.818401C14.1658 0.77644 14.1583 0.734267 14.1426 0.695354C14.1269 0.65663 14.1037 0.621418 14.0742 0.591839C14.0445 0.562165 14.0086 0.538219 13.9697 0.522503C13.931 0.506908 13.8894 0.499323 13.8477 0.500042C13.8057 0.500782 13.7639 0.510306 13.7256 0.527386C13.6874 0.544459 13.6525 0.569038 13.624 0.599651L13.6182 0.606487L13.6113 0.612347L7.68555 6.52055L7.33301 6.87211L6.97949 6.52055L1.05371 0.612347L1.04102 0.599651C1.01241 0.568948 0.977786 0.544465 0.939453 0.527386C0.901246 0.510374 0.86017 0.500826 0.818359 0.500042C0.776398 0.499302 0.734225 0.506786 0.695312 0.522503C0.656419 0.538218 0.621464 0.562171 0.591797 0.591839C0.56213 0.621509 0.538176 0.656453 0.522461 0.695354C0.506744 0.734266 0.49926 0.776441 0.5 0.818401C0.500787 0.860211 0.510334 0.901294 0.527344 0.939495C0.544424 0.977828 0.568907 1.01245 0.599609 1.04106L0.612305 1.05375L7.11133 7.55375L7.1123 7.55278C7.1709 7.6113 7.25019 7.64457 7.33301 7.64457Z" stroke="#000000"/>
                          </svg>
                      </button></div>`;
        });
        dhtml += `</div>`;
        $discounts.html(dhtml).show();
      } else {
        $discounts.hide();
      }

      // Duties
      if (cart.total_duties) {
        $duties
          .html(
            `<strong>Duties:</strong> ${this.formatMoney(cart.total_duties)}`
          )
          .show();
      } else {
        $duties.hide();
      }

      // Taxes
      if (cart.total_tax) {
        $tax
          .html(`<strong>Tax:</strong> ${this.formatMoney(cart.total_tax)}`)
          .show();
      } else {
        $tax.hide();
      }

      // Total price
      $total.html(
        `<strong>Total:</strong> ${this.formatMoney(cart.total_price)}`
      );

      this.updateCartBadge(cart.item_count);
      this.updateFreeShippingProgress(cart);
      this.trapFocus();
      if (cart.item_count === 0) {
        $(".acs-cart-free_shipping_message, .acs-cart-footer").hide();
      } else {
        $(".acs-cart-free_shipping_message, .acs-cart-footer").show();
      }
    },

    renderCartItem: function (item, index) {
      if (item.quantity <= 0) return "";

      // LINE-LEVEL DISCOUNTS
      let discounts = "";
      if (item.discounts?.length) {
        discounts += `<div class="acs-cart-item-discounts">`;
        item.discounts.forEach((d) => {
          discounts += `<span class="acs-cart-item-discount">${d.title}</span>`;
        });
        discounts += `</div>`;
      }

      // PROPERTIES (custom line-item data)
      let propsHTML = "";
      if (item.properties && Object.keys(item.properties).length > 0) {
        propsHTML += `<ul class="acs-cart-item-properties">`;
        for (const key in item.properties) {
          if (item.properties[key] && key != '__essential_upsell_funnel_id')
            propsHTML += `<li><strong>${key}:</strong> ${item.properties[key]}</li>`;
        }
        propsHTML += `</ul>`;
      }

      // SELLING PLAN (Subscription info)
      let sellingPlanHTML = item.selling_plan_allocation
        ? `<div class="acs-cart-item-sellingplan">${item.selling_plan_allocation.selling_plan.name}</div>`
        : "";

      return `
  <div class="acs-cart-item" data-line="${index + 1}">
  <span class="btn-loader"></span>
    <a href="${item.url}"><img src="${item.image}" alt="${item.title}" class="acs-cart-item-image"></a>

    <div class="acs-cart-item-details">
      <div class="col">
      <div class="acs-cart-item-title"><a href="${item.url}">${item.title}</a></div>

      <div class="acs-cart-item-variant">${item.variant_title || ""}</div>

      <!-- Extra Shopify Info -->
      ${
        item.sku
          ? `<div class="acs-cart-item-sku"><strong>SKU:</strong> ${item.sku}</div>`
          : ""
      }
      ${
        item.vendor
          ? `<div class="acs-cart-item-vendor"><strong>Vendor:</strong> ${item.vendor}</div>`
          : ""
      }
      ${
        item.product_type
          ? `<div class="acs-cart-item-type"><strong>Type:</strong> ${item.product_type}</div>`
          : ""
      }

      ${sellingPlanHTML}
      ${propsHTML}
      ${discounts}

      
      </div>
      <div class="col">
          <div class="acs-cart-item-price">
          ${
            item.original_line_price != item.final_line_price
              ? `<span class="acs-cart-item-price-original">${this.formatMoney(
                  item.original_line_price
                )}</span>`
              : ``
          }
          <span class="acs-cart-item-price-final">${this.formatMoney(
            item.final_line_price
          )}</span>
        </div>
        <div class="acs-cart-item-quantity">
        <button class="acs-quantity-btn acs-quantity-minus" data-line="${
          index + 1
        }">-</button>
        <input type="number" class="acs-quantity-input" value="${
          item.quantity
        }" min="0" data-line="${index + 1}">
        <button class="acs-quantity-btn acs-quantity-plus" data-line="${
          index + 1
        }">+</button>
      </div>
      </div>
    </div>

    

    <button class="acs-remove-item" data-line="${
      index + 1
    }" aria-label="Remove ${item.title}">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.5 1L1 9.5" stroke="#45523E" stroke-opacity="0.5"/>
          <path d="M1 1L9.5 9.5" stroke="#45523E" stroke-opacity="0.5"/>
        </svg>
    </button>
  </div>`;
    },

    /* ---------- QUANTITY UPDATE ---------- */
    updateQuantity: function (e) {
      e.preventDefault();

      var line = parseInt($(e.target).data("line"));
      if (!line) return;

      var $row = $(`[data-line="${line}"]`);
      var $input = $row.find(".acs-quantity-input");
      var quantity = parseInt($input.val()) || 1;
      $input.attr("data-previous-qty", quantity);

      if ($(e.target).hasClass("acs-quantity-minus") && quantity >= 1)
        quantity--;
      if ($(e.target).hasClass("acs-quantity-plus")) quantity++;

      $input.val(quantity);

      $(e.target).closest(".acs-cart-item").addClass("acs-updating");

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { line: line, quantity: quantity },
        dataType: "json",
        success: this.updateCartSuccess.bind(this, $(e.target)),
        error: this.updateCartError.bind(this, $(e.target)),
      });
    },
    updateFreeShippingProgress: function(cart) {
      var threshold = window.__shippingDiscountAfter || 7500;
      var subtotal = cart.items_subtotal_price;

      var progress = Math.min((subtotal / threshold) * 100, 100);

      $(".acs-cart__progress-bar-meter-fill")
        .css("width", progress + "%")
        .attr("aria-valuenow", Math.round(progress));

      if (subtotal >= threshold) {
        $(".acs-cart__progress-bar-prompt").html(
          "You get <b>FREE STANDARD SHIPPING</b>"
        );
      } else {
        var remaining = threshold - subtotal;

        $(".acs-cart__progress-bar-prompt").html(
          `You are ${this.formatMoney(
            remaining
          )} away from <b>FREE SHIPPING</b>`
        );
      }
    },

    /* ---------- REMOVE ITEM (FIXED) ---------- */
    removeItem: function (e) {
      e.preventDefault();
      var line = $(e.target).data("line");
      // console.log(e.target, line);
      $(e.target).closest(".acs-cart-item").addClass("acs-updating");
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { line: line, quantity: 0 },
        dataType: "json",
        success: this.updateCartSuccess.bind(this, $(e.target)),
        error: this.updateCartError.bind(this, $(e.target)),
      });
    },

    updateCartSuccess: function ($btn, cart) {
      $btn.closest(".acs-cart-item").removeClass("acs-updating");
      this.renderCart(cart);
    },

    updateCartError: function (xhr, $btn) {
      var message = "Cart update failed. Please try again.";

      try {
        var json = JSON.parse(xhr.responseText);
        if (json && (json.description || json.message)) {
          message = json.description || json.message;
        }
      } catch (e) {}
      $btn.closest(".acs-cart-item").removeClass("acs-updating");

      // ⬇️ restore quantity if a change request failed
      var $input = $(
        ".acs-quantity-input:focus, .acs-quantity-input[data-previous-qty]"
      );
      if ($input.length) {
        var previousQty = $input.data("previous-qty");
        if (previousQty) $input.val(previousQty);
      }

      // Show error message inside cart
      $(".acs-cart-error").text(message).fadeIn(200);

      // Auto-hide after 4 seconds
      setTimeout(function () {
        $(".acs-cart-error").fadeOut(200);
      }, 4000);
    },

    addToCartError: function ($form, xhr) {
      var message = "Unable to add to cart.";
      var $formbtn = $form.find('button[type="submit"], input[type="submit"]');
      $formbtn.prop("disabled", false);
      $formbtn.removeClass("disabled");

      try {
        var json = JSON.parse(xhr.responseText);
        if (json && (json.description || json.message)) {
          message = json.description || json.message;
        }
      } catch (e) {}

      $(".acs-cart-error").text(message).fadeIn(200);

      setTimeout(function () {
        $(".acs-cart-error").fadeOut(200);
      }, 4000);
    },

    /* ---------- BADGE ---------- */
    updateCartBadge: function (count) {
      var $badge = $(".acs-cart-toggle sup");
      if (typeof count === "undefined") {
        $.getJSON("/cart.js", function (cart) {
          $badge
            .text(cart.item_count > 0 ? cart.item_count : "")
            .toggle(cart.item_count > 0);
        });
      } else {
        $badge.text(count > 0 ? count : "").toggle(count > 0);
      }
    },

    /* ---------- MONEY FORMAT ---------- */
    formatMoney: function (cents) {
      if (typeof cents !== "number") cents = parseInt(cents);

      // fallback if shop money format wasn't injected
      var format = window.__acsMoneyFormat || "${{amount}}";

      var value = cents / 100;
      var formatted = "";

      // Basic decimals formatting
      formatted = value.toFixed(format.includes("no_decimals") ? 0 : 2);

      // Thousand separators for formats that use commas or spaces
      formatted = formatted.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        format.includes("comma") ? "." : ","
      );

      // Replace {{amount}} and {{amount_no_decimals}} in Shopify money formats
      return format
        .replace("{{amount_no_decimals}}", Math.round(value))
        .replace("{{amount}}", formatted)
        .replace("{{amount_with_comma_separator}}", formatted.replace(".", ","))
        .replace(
          "{{amount_no_decimals_with_comma_separator}}",
          Math.round(value)
        );
    },

    /* ---------- ACCESSIBILITY ---------- */
    trapFocus: function () {
      var $sidebar = $(".acs-cart-sidebar");
      var $focusable = $sidebar.find(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      var $first = $focusable.first(),
        $last = $focusable.last();
      $first.focus();
      $sidebar.on("keydown", function (e) {
        if (e.key === "Tab") {
          if (e.shiftKey && document.activeElement === $first[0]) {
            $last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === $last[0]) {
            $first.focus();
            e.preventDefault();
          }
        }
      });
    },

    restoreFocus: function () {
      $(".acs-cart-toggle").focus();
    },
  };

  $(document).ready(function () {
    ACS.init();
  });

  build_my_own_init(ACS);
})(jQuery);
